import cx from '@utils/cx.util';
import { memo } from 'react';

type Props = {
  eligibleForFreeShipping: boolean;
  amountRemainingForFreeShippingFormatted?: string;
  meterProgressFormatted?: string;
  className?: string;
};

const FreeShippingMeter = ({
  eligibleForFreeShipping,
  amountRemainingForFreeShippingFormatted,
  meterProgressFormatted,
  className = '',
}: Props) => {
  if (meterProgressFormatted == null) return null;

  return (
    <div
      className={cx(
        'tw:border-y tw:border-gray-300 tw:bg-free-shipping-meter-bg tw:px-4 tw:py-4 tw:md:px-5',
        className
      )}>
      <h5 className='tw:block tw:text-center tw:text-base tw:font-bold tw:text-free-shipping-meter-text'>
        {eligibleForFreeShipping ? (
          <>YOUR ORDER SHIPS FOR FREE!</>
        ) : (
          <>{amountRemainingForFreeShippingFormatted} to go for FREE SHIPPING!</>
        )}
      </h5>
      <div className='tw:mt-[10px] tw:block tw:h-[10px] tw:rounded-md tw:bg-free-shipping-meter-empty'>
        <span
          className='tw:block tw:h-full tw:rounded-md tw:bg-free-shipping-meter-filled'
          style={{ width: meterProgressFormatted ?? 0 }}></span>
      </div>
    </div>
  );
};

export default memo(FreeShippingMeter);
